module.exports = __webpack_public_path__ + "public/images/wallet-icon.bc585286e1f67d490c5f675c97141d4c.svg";